<template>
  <div class="premium-modale">
    <p>
      <span class="cross-button" @click="$emit('close')">
        &#10005;
      </span>
      This alloy is only available to Premium Users. <br /><br />
      Log in or request IDs through email at
      <a class="mail" href="mailto:contact@lebronze-alloys.com">
        contact@lebronze-alloys.com
      </a>
    </p>
    <span class="overlay" @click="$emit('close')"></span>
  </div>
</template>

<script>
export default {
  name: "PremiumAlloyModale",
  emits: ["close"],
  methods: {
    closeModale() {}
  }
};
</script>

<style scoped lang="scss">
.premium-modale {
  width: 100%;
  height: 100%;
  min-height: 500px;
  position: absolute;
  top: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  p {
    position: relative;
    color: white;
    background: rgba(0, 0, 0, 0.8);
    padding: 30px;
  }
  .overlay {
    background: rgba(0, 0, 0, 0.4);
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -1;
  }
}

.cross-button {
  width: 20px;
  height: 20px;
  background-color: red;
  color: white;
  border-radius: 10px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  font-size: 14px;
  font-weight: bold;
  object-position: 50% 50%;
  transform: translate(50%, -50%);

  &:hover {
    cursor: pointer;
  }
}

.mail {
  color: white;
  text-decoration: underline;
}
</style>
